/**
 * SyproFlow → Tally Bridge Export
 * Sends extraction data to local Tally Bridge for approval and push to Tally.
 *
 * Tally Bridge must be running at localhost:8765
 * Uses form POST (not fetch) to avoid CORS issues and open in new tab.
 */

const TALLY_BRIDGE_URL = 'http://localhost:8765';

/**
 * Check if Tally Bridge is running
 * @returns {Promise<{connected: boolean, tallyConnected: boolean, company: string|null}>}
 */
export async function checkTallyBridge() {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2000);
    const res = await fetch(`${TALLY_BRIDGE_URL}/status`, {
      signal: controller.signal,
      mode: 'cors'
    });
    clearTimeout(timeout);
    const data = await res.json();
    return {
      connected: true,
      tallyConnected: data.tally_connected || false,
      company: data.company || null
    };
  } catch {
    return { connected: false, tallyConnected: false, company: null };
  }
}
